// extracted by mini-css-extract-plugin
export var arrow = "X_9";
export var career = "X_ds";
export var careerContainer = "X_dr";
export var container = "X_k";
export var link = "X_bs";
export var location = "X_b6";
export var section = "X_b";
export var title = "X_f";